import { atom } from "recoil";

const authenticated = atom({
    key: 'authenticated',
    default: {
        check: false || window.localStorage.getItem('token') !== null,
        token: null || window.localStorage.getItem('token'),
        isExpired: false,
    }
});


export {authenticated};